<template>
  <footer class="footer">
    <div class="container footer-content">
      <div class="row footer-top">
        <div class="col-sm-6 col-xl-4 footer-top-contact" id="footerTop">
          <h3>Contact Us</h3>
          <div class="hr"></div>

          <address class="mb-0">

            <div>
              <a href="tel:01359 232335">(01359) 232335</a>
            </div>

            <p>
              Willow Cottage <br />
              Pakenham Rd <br />
              Thurston <br />
              Suffolk <br />
              IP31 3QJ
            </p>
          </address>
        </div>

        <div class="col-sm-6 col-xl-4 mt-5 mt-sm-0 footer-top-navigation" id="footerTop2">
          <h3>Sections</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/our-services/"
                >Our Services</router-link
              >
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/why-choose-us/">
                Why Choose Us
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/contact-us/"
                >Contact Us</router-link
              >
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-xl-4 mt-5 mt-xl-0 footer-top-legal" id="footerTop3">
          <h3>Legal</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/privacy-cookie-policy/"
              >Privacy & Cookie Policy</router-link>
            </li>
          </ul>
        </div>
      </div>

      <GoogleMapsEmbed height="250" />
    </div>

    <div class="container-fluid footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <p class="footer-bottom-copyright">
              Copyright {{ copyrightDate }} &copy; Eco Sweep All
              Rights Reserved.
            </p>
          </div>

          <div class="col-lg-6">
            <p class="footer-bottom-nm-link">
              <a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Website Design</a
              >&nbsp;by&nbsp;<a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Netmatters</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import GoogleMapsEmbed from '@/components/partials/GoogleMapsEmbed'

export default {
  components: {
    FontAwesomeIcon,
    GoogleMapsEmbed
  },
  data () {
    return {
      name: 'main-footer',
      copyrightDate: '',
      faFacebookF
    }
  },
  mounted () {
    this.copyrightDate = new Date().getFullYear()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.footer {
  background-color: $clr-theme-black;
  color: $white;
  font-size: 0.875rem;

  .hr {
    width: 100px;
    height: 3px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;

    @media (min-width: $sm-breakpoint) {
      margin-left: 0;
      margin-right: 0;
    }

    background-color: $clr-theme-green;
  }

  h3 {
    letter-spacing: 0.02em;
  }

  p {
    font-size: 0.875rem;
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  address {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    a {
      display: block;
    }
  }

  &-top {
    text-align: center;

    @media (min-width: $sm-breakpoint) {
      text-align: left;
    }

    p,
    a {
      font-weight: 500;
      color: inherit;
    }

    a,
    li {
      + * {
        margin-top: 0.5rem;
      }
    }

    &-social {
      display: flex;
      flex-direction: column;

      &-facebook {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: center;

        @media (min-width: $sm-breakpoint) {
          justify-content: normal;
        }

        &:hover {
          svg path {
            fill: $white;
          }
        }

        svg path {
          fill: $clr-theme-green;
        }
      }
    }
  }

  #footerTop, #footerTop2, #footerTop3 {
    @media (min-width: $xs-breakpoint) {
       flex: 0 0 50%;
       max-width: 50%;
    }
    @media (min-width: $sm-breakpoint) {
       flex: 0 0 33%;
       max-width: 33%;
    }
    @media (min-width: $sm-md-breakpoint) {
       flex: 0 0 33%;
       max-width: 33%;
    }
    @media (min-width: $md-breakpoint) {
       flex: 0 0 33%;
       max-width: 33%;
    }
  }

  #footerTop2 {
    @media (min-width: $xs-breakpoint) {
       margin-top: 0 !important;
    }
  }

  #footerTop3 {
    @media (min-width: $xs-breakpoint) {
       margin-top: 3rem !important;
    }
    @media (min-width: $sm-breakpoint) {
      margin-top: 0 !important;
    }
    @media (min-width: $sm-md-breakpoint) {
       margin-top: 0 !important;
    }
    @media (min-width: $md-breakpoint) {
       margin-top: 0 !important;
    }
  }

  &-content {
    padding-top: 38px;
    padding-bottom: 38px;

    display: flex;
    flex-direction: column;
    gap: 38px;
  }

  &-middle {
    p {
      font-weight: 400;
    }
  }

  &-bottom {
    background-color: #1a1a1a;
    padding-top: 15px;
    padding-bottom: 15px;

    &-copyright {
      font-size: 13px;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }
    }

    &-nm-link {
      font-size: 13px;
      text-align: right;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }

      a {
        color: $white;
        text-decoration: underline;

        &:hover {
          color: $white !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue